import React, { useEffect } from 'react'
import { Alert } from 'components'
import { Form } from 'components/Form'
import { alerts as alertKeys, gender } from 'keys'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { validate, contactUsHooks, uploadAudioHooks } from '.'
import { initialize, reset } from 'redux-form'
import { ContactUsAlertStyles } from './Style'
import contactUs from './hooks'
import { secretStorage } from 'config'

const UploadAudioPopup = () => {
    const dispatch = useDispatch()
    const { formname, getTitle } = contactUs.constants
    const formValues = useSelector(state => state.form[formname]?.values)
    const { request_type } = formValues || {}

    const secretUser = secretStorage.getItem("user")
    const isMaleGender = secretUser.gender === gender.male

    const setAlert = contactUsHooks.useAlert()
    const formFields = contactUsHooks.useFormFields()
    const submitBtns = contactUs.useSubmitBtns()

    useEffect(() => {
        return (() => {
            dispatch(reset(formname))
            dispatch(initialize(formname, {}));
        })
    }, [])

    return (
        <Alert
            systemUI
            title={request_type?.name || getTitle(isMaleGender)}
            footerActions={submitBtns}
            handleAlert={() => setAlert(false)}
            closeOnClick
        >
            <ContactUsAlertStyles>
                <Form
                    form={formname}
                    validations={validate}
                    fields={formFields}
                    submit={() => { }}
                />
            </ContactUsAlertStyles>
        </Alert>
    )
}

export default UploadAudioPopup